export enum ImageStyle { Curved, NoGap, RectAngle };